const PlatformImage = ({ src }) => (
  <div>
    <img src={src} alt="computer" style={{ maxWidth: "350px"}}/>
  </div>
);

export default PlatformImage;
